var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.orderline.product.name))]),_c('td',[_vm._v(_vm._s(_vm.orderline.quantity)+" stk")]),_c('td',[_vm._v("kr "+_vm._s(_vm.subtotal)+",-")])])}
var staticRenderFns = []

export { render, staticRenderFns }